import { combineReducers } from "redux";
import * as types from "./types";
import { createReducer } from "../../utils";

const listReducer = createReducer([])({
    [types.FETCH_QUESTION_LIST_COMPLETED]: (state, action) => {
        return action.payload.payload
    },
    [types.INSERT_QUESTION_COMPLETED]: (state, action) => {
        const event = action.payload.payload;
        state.push(event)
        return state.slice()
    },
    [types.UPDATE_QUESTION_COMPLETED]: (state, action) => {
        const question = action.payload.payload
        return state.map(e => e.id === question.id ? question : e)
    },      
    [types.DELETE_QUESTION_COMPLETED]: (state, action) => {
        const event = action.payload.payload;
        state.push(event)
        return state.slice()
    },
});

export default combineReducers({
    list: listReducer
});